/**
 * sentence.tldr.fm serves only the sentence page, at its root. Any hostname
 * whose first label is `sentence` qualifies, so a test environment's name
 * works too. Every other host keeps the full app.
 */
export function isSentenceHost(hostname: string): boolean {
  return hostname.toLowerCase().split('.')[0] === 'sentence';
}

/** sentence-admin.tldr.fm: the sentence feeds' knobs and health, for sentence admins only. */
export function isSentenceAdminHost(hostname: string): boolean {
  return hostname.toLowerCase().split('.')[0] === 'sentence-admin';
}

/** The sentence page's time filters, in hours; the first is the default. */
export const SENTENCE_WINDOWS = [24, 72, 168] as const;
export type SentenceWindowHours = (typeof SENTENCE_WINDOWS)[number];

/** "24h", "72h", "7d": the label shown and the `window` value sent to the API. */
export function sentenceWindowLabel(hours: SentenceWindowHours): string {
  return hours === 168 ? '7d' : `${hours}h`;
}

/** The window a `?window=` value names, or the default for anything else. */
export function parseSentenceWindow(value: string | null): SentenceWindowHours {
  return SENTENCE_WINDOWS.find((hours) => sentenceWindowLabel(hours) === value) ?? SENTENCE_WINDOWS[0];
}
